import React from 'react'
import Alert from 'react-bootstrap-sweetalert'
import { Box, Typography } from '@material-ui/core'
import './styles.css'
import Cookies from 'js-cookie'
import Modal from '@mui/material/Modal';
import { Button as ButtonMui } from 'components/storybook'
import Button from 'components/CustomButtons/Button.jsx'

export function AlertStatus({ hideAlert, sendEmail, accountData, contact, themeColor, open }) {


    return (
        <Modal
            open={open}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
            sx={{ backdropFilter: 'blur(2px)', }}
        >
            <Box
                sx={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%)',
                    width: '100%',
                    maxWidth: 470,
                    bgcolor: '#FFFFFF',
                    p: '20px',
                    borderRadius: '10px',
                    gap: '16px',
                    display: 'flex',
                    flexDirection: 'column',
                    alignItems: 'center',
                }}
            >

                <Box display="flex " width="100%" justifyContent="flex-end" >
                    <Button
                        color="danger"
                        size="sm"
                        style={{ height: "40px", }}
                        onClick={hideAlert}
                    >
                        Fechar
                    </Button>
                </Box>
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        flexDirection: 'column',
                        gap: '20px'
                    }}
                >
                    <Box component="a" className='icon-informacao' color="#ffb273" fontSize="70px" />
                    <Box textAlign="center">
                        <Typography className="title">
                            Identificamos que o seu cadastro já foi iniciado, mas
                            seu e-mail ainda não foi validado.
                        </Typography>
                        <Typography className="title">
                            Reenvie o e-mail para
                            {` ${accountData?.email || '-'}`} e realize a validação
                        </Typography>

                        <Typography className="description">
                            Caso não tenha recebido, verifique sua pasta de lixo
                            eletrônico(spam) ou entre em contato com o suporte
                        </Typography>

                        <Typography
                            style={{
                                color: `${themeColor}`,
                                fontSize: '13px',
                                textAlign: 'center',
                            }}
                        >
                            {`Email: ${contact?.contactEmail || '-'}`}
                        </Typography>

                        <Typography
                            style={{
                                color: `${themeColor}`,
                                fontSize: '13px',
                            }}
                        >
                            {`Telefone: ${contact?.contactPhoneNumber || '-'}`}
                        </Typography>
                    </Box>
                    <Box width='200px' >
                        <ButtonMui
                            defaultColor={themeColor?.navigation?.buttons?.backgroundColor}
                            outlined="outlined"
                            text={"Reenviar e-mail"}
                            textColor="#FFFFFF"
                            typeVariation="CustomTextButton"
                            borderRadius="5px"
                            onClick={sendEmail}
                        />
                    </Box>
                </Box>
            </Box>
        </Modal>
    )
}
